import { Link, useLocation } from 'react-router-dom'

export interface NavigationItem {
  name: string
  path: string
}

interface NavigationProps {
  items: NavigationItem[]
  className?: string
  mobile?: boolean
  onItemClick?: () => void
}

export function Navigation({ 
  items, 
  className = '', 
  mobile = false,
  onItemClick 
}: NavigationProps) {
  const location = useLocation()

  if (mobile) {
    return (
      <div className={`space-y-1 ${className}`}>
        {items.map((item) => {
          const isActive = location.pathname === item.path
          return (
            <Link
              key={item.path}
              to={item.path}
              onClick={onItemClick}
              className={`block px-3 py-2 rounded-lg text-base font-medium transition-colors ${
                isActive
                  ? 'text-primary-600 bg-primary-600/10'
                  : 'text-neutral-700 hover:bg-neutral-100'
              }`}
            >
              {item.name}
            </Link>
          )
        })}
      </div>
    )
  }

  return (
    <nav className={`flex items-center gap-6 ${className}`}>
      {items.map((item) => {
        const isActive = location.pathname === item.path
        return (
          <Link
            key={item.path}
            to={item.path}
            className={`text-sm font-medium transition-colors ${
              isActive
                ? 'text-primary-600'
                : 'text-neutral-700 hover:text-primary-600'
            }`}
          >
            {item.name}
          </Link>
        )
      })}
    </nav>
  )
}

